import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  Table, Modal, Message, Button,
} from 'semantic-ui-react';
import { map, isEmpty } from 'lodash';
import { utcMoment } from '../../utilities/dateUtils';
import { addDupeVehicleIndex } from '../../data/duplicateVehicleIndex/actions';

class DuplicateVehicleModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
    };
  }

  removeDuplicateVehicle = (vin, dealerNumber) => () => {
    const { values, dispatch } = this.props;
    const { vehicles } = values;
    vehicles.filter(
      item => !(item.vin === vin && item.dealerNo === dealerNumber)
    );

    vehicles.map((item, index) => {
      if (item.vin === vin && item.dealerNo === dealerNumber) {
        dispatch(
          addDupeVehicleIndex({
            vin: item.vin,
            dealerNumber: item.dealerNo,
            index,
          })
        );
        this.setState({
          message: 'Deleted the record successfully with VIN ' + item.vin,
        });
      }
      return {};
    });
  };

  render() {
    const {
      onDupeVehicleModalCloseHandler,
      isDupeVehicleModalOpen,
      duplicateVehicles,
      keepDuplicateVehicle,
      keepDuplicateVehicleMessage,
      values: { vehicles },
    } = this.props;

    const { message } = this.state;
    const duplicateVehiclesToShow = [];
    if (!isEmpty(duplicateVehicles) && !isEmpty(vehicles)) {
      map(duplicateVehicles, vehicle => {
        const existingVehicle = vehicles.filter(
          item => item.vin === vehicle.vin && item.dealerNo === vehicle.dealerNumber
        );
        if (!isEmpty(existingVehicle)) {
          duplicateVehiclesToShow.push(vehicle);
        }
      });
    }

    const TableHeader = (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>VIN</Table.HeaderCell>
          <Table.HeaderCell>Dealer No</Table.HeaderCell>
          <Table.HeaderCell>Dealer Name</Table.HeaderCell>
          <Table.HeaderCell>Auction Name</Table.HeaderCell>
          <Table.HeaderCell>Date of Guarantee</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Header>
    );

    return (
      <Modal
        open={isDupeVehicleModalOpen}
        closeIcon
        onClose={onDupeVehicleModalCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
        size='large'
      >
        <Modal.Header>
          A guarantee already exists for the below VINs:
        </Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            {!isEmpty(keepDuplicateVehicleMessage) && (
              <Message positive>
                <p>{keepDuplicateVehicleMessage}</p>
              </Message>
            )}
            {!isEmpty(message) && (
              <Message positive>
                <p>{message}</p>
              </Message>
            )}
            <Table celled singleLine verticalAlign='top'>
              {TableHeader}
              <Table.Body>
                {map(duplicateVehiclesToShow, vehicle => (
                  <Table.Row key={vehicle.vin}>
                    <Table.Cell>{vehicle.vin}</Table.Cell>
                    <Table.Cell>{vehicle.dealerNumber}</Table.Cell>
                    <Table.Cell>{vehicle.dealerName}</Table.Cell>
                    <Table.Cell>{vehicle.auctionName}</Table.Cell>
                    <Table.Cell>
                      {isEmpty(vehicle.guaranteedAt)
                        ? ''
                        : utcMoment(vehicle.guaranteedAt).format('MM/DD/YYYY')}
                    </Table.Cell>
                    <Table.Cell>
                      <Button
                        onClick={keepDuplicateVehicle(
                          vehicle.vin,
                          vehicle.dealerNumber
                        )}
                      >
                        Continue
                      </Button>
                    </Table.Cell>
                    <Table.Cell>
                      <Button
                        onClick={this.removeDuplicateVehicle(
                          vehicle.vin,
                          vehicle.dealerNumber
                        )}
                      >
                        Delete
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

DuplicateVehicleModal.propTypes = {
  onDupeVehicleModalCloseHandler: PropTypes.func.isRequired,
  isDupeVehicleModalOpen: PropTypes.bool.isRequired,
  duplicateVehicles: PropTypes.array.isRequired,
  keepDuplicateVehicle: PropTypes.func.isRequired,
  keepDuplicateVehicleMessage: PropTypes.string,
  values: PropTypes.shape({
    vehicles: PropTypes.array,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const {
    data: { duplicateVehicles },
    form: {
      npForm: { values },
    },
  } = state;
  return {
    duplicateVehicles,
    values,
  };
};

export default compose(connect(mapStateToProps))(DuplicateVehicleModal);
